import { createTheme } from '@mui/material';

import colors from './colors';

const theme = createTheme({
    typography: {
        fontFamily: 'Roboto',
        fontSize: 14,
        h1: {
            fontSize: '48px',
            fontWeight: 700,
        },
        h2: {
            fontSize: '24px',
            fontWeight: 600,
        },
        h3: {
            fontSize: '20px',
            fontWeight: 700,
        },
        h4: {
            fontSize: '18px',
            fontWeight: 500,
        },
        h5: {
            fontSize: '12px',
            fontWeight: 500,
        },
        h6: {
            fontSize: '11px',
            fontWeight: 700,
        },
        body1: {
            fontSize: '14px',
            fontWeight: 400,
        },
        body2: {
            fontSize: '12px',
            fontWeight: 400,
        },
    },
    palette: {
        primary: {
            main: colors.blue.main,
            light: colors.blue.light,
            dark: colors.blue.dark,
        },
        error: {
            main: colors.red.main,
            light: colors.red.light,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: 'Roboto',
                },
            },
        },
    },
});

export default theme;
